import methods from "@/global/methods.js";
import apivalidation from "@/global/apivalidation.js";

export default {
    /* turn the layout settings into CSS variables so the page will be styled according to the settings */
    addLayoutValues(state, arg) {
        let html = document.getElementsByTagName("html")[0];
        let acceptedFontProps = [`Color`, `FontSize`, `FontFamilyPublicName`];
        
        arg = apivalidation.validate(arg, `layout`, true);
        
        // Add CSS variables for all the elements that can be styled
        [`QuestionStyling`, `AnswerStyling`, `DescriptionStyling`].forEach((element) => {
            for (let key in arg[element]) {
                if (acceptedFontProps.includes(key)) {
                    let hyphenedKey = methods.hyphenate(key);
                    html.style.setProperty(`--${element}-${hyphenedKey}`, arg[element][key]);
                }
            }
        });
       
        html.style.setProperty(`--background-color`, arg.BackgroundColor);
        html.style.setProperty(`--background-image`, `url(${arg.BackgroundImagePath})`);
        html.style.setProperty(`--primary-color`, arg.PageStyling.Color);
        html.style.setProperty(`--progressbar-color`, arg.ProgressBar.ProgressBarColor);
        html.style.setProperty(`--progresspercentage-color`, arg.ProgressBar.PercentageColor);        
        html.style.setProperty(`--encouragement-color`, arg.EncouragementColor);
        html.style.setProperty(`--page-font-family-public-name`, arg.PageStyling.FontFamilyPublicName);
        html.style.setProperty(`--next-button-background-color`, arg.NextButtonBackGroundColor);
        html.style.setProperty(`--next-button-font-family`, arg.NextButtonStyling.FontFamilyPublicName);
        html.style.setProperty(`--next-button-font-size`, arg.NextButtonStyling.FontSize);
        html.style.setProperty(`--next-button-font-color`, arg.NextButtonStyling.Color);       
        html.style.setProperty(`--back-button-background-color`, arg.BackButtonBackGroundColor);
        html.style.setProperty(`--back-button-font-family`, arg.BackButtonStyling.FontFamilyPublicName);
        html.style.setProperty(`--back-button-font-size`, arg.BackButtonStyling.FontSize);
        html.style.setProperty(`--back-button-font-color`, arg.BackButtonStyling.Color);
        html.style.setProperty(`--check-color`, arg.ProgressBar.CheckColor);

        state.layout = arg;
    },
    addText(state, arg) {
        state.text = arg.textResources;
    },
    addSurveyInfo(state, arg) {
        for (let infoName in arg) {
            if (infoName !== `actionObject`) state.surveyInfo[infoName] = arg[infoName];
        }
    },
    addQueryParam(state, arg) {
        for (let argName in arg) {
            state.surveyInfo.queryParams[argName] = arg[argName];
        }
    },
    addLanguages(state, arg) {
        if (arg !== null) {
            state.languages = arg;
        }
    },
    updateFormValidation(state) {
        let form = document.getElementById(`form`);

        state.global.formIsValid = form ? form.checkValidity() : false;
    },
    addServerMessages(state, message) {
        state.message = message;
    },
    addPageData(state, arg) {
        const queryParams = state.surveyInfo.queryParams;
        
        state.page = arg.page;
        
        // Save data in sessionstorage so they can be used when the user refresh the page
        sessionStorage.setItem(`respondentId`, state.page.respondentId);
        sessionStorage.setItem(`sessionId`, state.page.sessionId);
        sessionStorage.setItem(`surveyId`, state.page.surveyId);
        sessionStorage.setItem(`pageId`, state.page.pageId);

        // Save the query parameters for the test flags, so we remember that the user is in a test environment(test vanaf hier)
        sessionStorage.setItem(`queryparams`, JSON.stringify(queryParams));

        if (state.surveyInfo.culture) sessionStorage.setItem(`culture`, state.surveyInfo.culture);
        else sessionStorage.setItem(`culture`, document.documentElement.lang);
    },
    changeGlobal(state, arg) {
        state.global[arg.variableName] = arg.newValue;
    },
    changeSettings(state, arg) {
        state.settings[arg.variableName] = arg.newValue;
    },
};
